<template>
  <div class="CompanyInfo">
    <div class="row">
      <div class="col">
        <div
          style="
            font-size: 32px;
            color: rgb(51, 51, 51);
            font-family: 微软雅黑, 'Microsoft YaHei';
          "
        >
          COMPANY PROFILE
        </div>

        <div
          style="
            color: rgb(51, 51, 51);
            font-size: 32px;
            font-family: 微软雅黑, 'Microsoft YaHei';
          "
        >
          公司简介
        </div>
        <br />
        <div
          style="
            font-size: 14px;
            line-height: 30px;
            display: inline-block;
            color: rgb(102, 102, 102);
          "
        >
          &nbsp;
          &nbsp;河北尼贝网络科技（公司官网：www.nibeikeji.com）中国的移动广告整合营销平台。成立于2023年8月。公司总部坐落于中国(河北)自由贸易试验区大兴机场片区廊坊临空经济区航谊道自贸区科创基地6620。公司核心管理团队具有多年丰富的互联网和移动互联网开发运营经验。多年来，尼贝依托雄厚的技术实力、持续不断的产品创新、强势媒体不断合作等优势成为移动广告领域的。探索平台作为尼贝旗下的移动广告平台，为提供众多优质广告主、保证广告质量、智能分配广告、有效提高收入。为广告主提供丰富的广告形式和广告创意表现；智能精准投放、定位到目标用户。让用户得到新奇的广告体验，为用户带来多重优惠；流畅使用流程，确保用户体验。始终以技术作为核心竞争力，继而打造一个综合型未来移动广告整合营销智能平台。为应用和广告主创造价值大化。尼贝一直秉承以用户需求为核心，在专注移动广告市场开拓的同时，为越来越多的新老客户量身打造品牌需求。以优质、用心的服务赢得了众多企业的信赖和好评，在整个行业逐渐树立起公司良好口碑。公司不仅仅提供专业的移动广告营销服务，同时还建立了完善的售后服务体系，为各广告主提供专业优质的服务，促进广告价值大化。我们相信，通过我们的不断努力和追求，一定能够实现与广大新老客户互利共赢！<!-- 公司为大家提供完善的薪酬结构，富有挑战性的薪酬水平和福利体系：·国家规定的五险一金，包括社保及住房公积金·国家规定年假，加班补助，调休，出差补助及人性化的假期安排等·重大传统节日及员工礼金和礼品发放·定期组织小伙伴们团队旅游及拓展活动,定期组织篮球、足球、羽毛球等体育项目·每年组织全面的健康体检·每月为大家供应咖啡、茶叶、果汁等饮品 -->
        </div>
      </div>
      <div class="col">
        <img
          src="@/assets/AD0IiNeHChACGAAgy7bC7wUoypvV8wcw8AM4gAQ.jpg.webp"
          alt=""
          srcset=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyInfo",
  props: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.CompanyInfo {
  .row {
    display: flex;
    text-align: left;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    width: 80%;
    margin: 0 auto;
    padding: 30px 0px;
    .col {
      padding: 10px 30px;
      width: 50%;
    }
  }
}
</style>
